import React from 'react';
import PropTypes from 'prop-types';
import {withRouter, Link} from 'react-router-dom';

import CoreLogo, {LOGO_TYPES, BRAND_TYPES} from '@stubhub/react-logo-core';

const Logo = (
  {className, onItemClick, location, href = '/', type, brand = BRAND_TYPES.DEFAULT},
  {globalRegistry, matchRoutes}
) => {
  const defaultLocale = globalRegistry?.getDefaultLocale();
  const currentLocale = globalRegistry?.getCurrentLocale();

  return (
    <CoreLogo
      defaultLocale={defaultLocale}
      currentLocale={currentLocale}
      LinkComp={Link}
      className={className}
      onItemClick={onItemClick}
      location={location}
      type={type}
      brand={brand}
      href={href}
      matchRoutes={matchRoutes}
    />
  );
};

Logo.propTypes = {
  /**
   * Custom classname.
   * If logo_merch or logo_white are provided, special styles will be applied though it's bette to use type prop
   */
  className: PropTypes.string,

  /**
   * Callback called when the logo is clicked. It will send 'StubHub Logo' as the argument
   */
  onItemClick: PropTypes.func,

  /**
   * Current location
   */
  location: PropTypes.object,

  /**
   * The logo href
   */
  href: PropTypes.string,

  /**
   * Available styles
   */
  type: PropTypes.oneOf([LOGO_TYPES.MERCH, LOGO_TYPES.WHITE]),

  /**
   * Logo brand
   */
  brand: PropTypes.oneOf([BRAND_TYPES.DEFAULT, BRAND_TYPES.ALTERNATIVE]),
};

Logo.contextTypes = {
  globalRegistry: PropTypes.object,
  matchRoutes: PropTypes.func,
};

export default withRouter(Logo);

export {LOGO_TYPES, BRAND_TYPES};
